/**
 * 
 * key
 * 
 */


const key = 'bXlDbGllbnRPZ1Bob3Rvcw=='

export default key 